<template>
    <div>
        <div class="title">{{$t('news.lista')}}</div>
        <hr>
        <div class="container">
            <div class="row-sezione pt-0">
                <!-- foreach news -->
                <div class="blocchetto" v-for="notice in news">
                    <div class="row">
                        <div class="col-md-3">
                            <img :src="getNewsImage(notice)"
                                 class="img-fluid img-thumbnail mx-auto">
                        </div>
                        <div class="col-md-9">
                            <p class="gray"><i class="fa fa-calendar mr-2"></i>
                                <i>
                                    {{moment(notice.created_at).locale(language).format('dddd DD MMMM YYYY')}}
                                </i>
                            </p>
                            <p>{{notice.traduzione.titolo}}</p>
                            <p v-html="displayNewsText(notice)"></p>
                            <router-link :to="{name: 'news.details', params: {id: notice.id}}"
                                         class="btn btn-primary btn-sm">{{$t('news.leggi')}}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getMixedInfo} from "../../api/restaurant";
    import {getImage} from "../../api/core";
    import {mapState, mapActions} from "vuex";

    export default {
        data: function () {
            return {
                news: []
            }
        },
        created() {
            this.fetchInfo();
        },
        computed: {
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('restaurant', {
                targa: state => state.targa,
                locale: state => state.locale,
                id_ristorante: state => state.id
            })
        },
        watch: {
            language: function (newLanguage, oldLanguage) {
                this.fetchInfo();
            }
        },
        methods: {
            fetchInfo: function () {
                this.showLoading(true);
                getMixedInfo(this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    news: true,
                }).then(response => {
                    this.news = response.news;
                }).catch(messages => {
                    alert(messages.join("\n"));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            getNewsImage: function (news) {
                return getImage(this.language, this.id_ristorante, news.foto_codice);
            },
            displayNewsText: function (news) {
                return news.traduzione.testo.length > 200 ?
                    news.traduzione.testo.substr(0, 200).replace(/\n/g, '<br>') + ' ... ' : news.traduzione.testo.replace(/\n/g, '<br>')
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
